import React, { useState, useEffect, useRef } from 'react'
import { supabase, getConfiguracoes, updateConfiguracao, stripeConnectEstado, stripeConnectLink, stripeConnectAtualizarEstado, vendusEstado, vendusGuardarKey, vendusTestar, vendusMetodosPagamento, getAgendamentosParaMarcarPagos, criarCobranca } from '../../lib/supabase'
import { parseMetodosPagamento, slugifyMetodo, METODO_STRIPE, estadoParcelas, fmtEur } from '../../lib/valores'
import { useTenant } from '../../contexts/TenantContext'
import { useToast } from '../../contexts/ToastContext'
import { useAuth } from '../../contexts/AuthContext'
import Loading from '../../components/Loading'

// Sinal esperado de uma marcação (mesma regra da Nova Marcação / Cobrar em
// conjunto): valor fixo do serviço ou percentagem global do preço.
function sinalEsperadoImportado(ag, config) {
  const svc = ag?.servicos
  if (svc?.sinal_valor != null && svc.sinal_valor !== '') return Number(svc.sinal_valor)
  const pct = parseFloat(config?.stripe_sinal_percentagem)
  if (!Number.isFinite(pct)) return 0
  const base = ag?.preco_total != null ? Number(ag.preco_total) : Number(svc?.preco || 0)
  return Math.round(base * pct) / 100
}

const inputStyle = {
  padding: '9px 12px', border: '1px solid var(--cor-borda)',
  borderRadius: 'var(--raio)', fontSize: '14px',
  fontFamily: 'var(--font-ui)', background: 'var(--cor-branco)', color: 'var(--cor-texto)',
  appearance: 'none', WebkitAppearance: 'none',
  textAlign: 'left', minHeight: '38px', boxSizing: 'border-box',
}

function Secao({ titulo, children }) {
  return (
    <div style={{
      background: 'var(--cor-branco)', border: '1px solid var(--cor-borda)',
      borderRadius: 'var(--raio-lg)', padding: '24px', marginBottom: '20px',
      boxShadow: 'var(--sombra)',
    }}>
      <p style={{ fontWeight: '600', color: 'var(--cor-principal)', marginBottom: '18px' }}>{titulo}</p>
      {children}
    </div>
  )
}

function Campo({ label, children }) {
  return (
    <div>
      <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500' }}>{label}</label>
      {children}
    </div>
  )
}

const DUMMY = {
  nome: 'Maria',
  nomeCompleto: 'Maria Silva',
  servico: 'Massagem Relaxante',
  data: 'sexta-feira, 13 de junho de 2025',
  hora: '14:30',
  horaFim: '15:30',
  profissional: 'Ana Silva',
  nomeNegocio: 'Estética Exemplo',
  morada: 'Rua das Flores, 12, Lisboa',
  telefone: '+351 910 000 000',
  notas: '',
  gcalUrl: '#',
}

const TEMPLATE_PADRAO = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style>
    body{font-family:'Jost',system-ui,sans-serif;font-weight:300;background:#faf7f5;margin:0;padding:0}
    .container{max-width:560px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.08)}
    .header{background:#8B4A2F;padding:36px 40px;text-align:center}
    .header h1{color:#fff;margin:0;font-size:26px;letter-spacing:3px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .header p{color:#e8d5c8;margin:8px 0 0;font-size:12px;letter-spacing:.08em;font-weight:300;font-family:'Jost',sans-serif}
    .body{padding:36px 40px}
    .greeting{font-size:20px;color:#333;margin-bottom:8px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .body p{font-family:'Jost',sans-serif;font-weight:300}
    .details{background:#faf7f5;border-radius:8px;padding:24px;margin:24px 0}
    .detail-row{margin-bottom:16px}
    .detail-row:last-child{margin-bottom:0}
    .detail-label{font-size:11px;color:#999;text-transform:uppercase;letter-spacing:.12em;margin-bottom:2px;font-weight:600;font-family:'Jost',sans-serif}
    .detail-value{font-size:15px;color:#333;font-weight:500;font-family:'Jost',sans-serif}
    .footer{background:#faf7f5;padding:24px 40px;text-align:center;border-top:1px solid #f0ebe7}
    .footer p{color:#999;font-size:12px;margin:4px 0;font-weight:300;font-family:'Jost',sans-serif}
    @media(max-width:600px){.container{margin:0;border-radius:0}.body{padding:24px 20px}.header{padding:28px 20px}}
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>{nomeNegocio}</h1>
      <p>Confirmação de Agendamento</p>
    </div>
    <div class="body">
      <p class="greeting">Olá, {nomeCompleto}!</p>
      <p style="color:#666;line-height:1.6">O seu agendamento foi confirmado com sucesso. Aguardamos a sua visita!</p>
      <div class="details">
        <div class="detail-row"><div><div class="detail-label">Serviço</div><div class="detail-value">{servico}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Profissional</div><div class="detail-value">{profissional}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Data</div><div class="detail-value">{data}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Hora</div><div class="detail-value">{hora} – {horaFim}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Morada</div><div class="detail-value">{morada}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Contacto</div><div class="detail-value">{telefone}</div></div></div>
      </div>
      <div style="text-align:center;margin:24px 0 8px">
        <a href="{gcalUrl}" target="_blank" style="display:inline-block;background:#8B4A2F;color:#fff;text-decoration:none;padding:12px 24px;border-radius:6px;font-size:14px;letter-spacing:.04em">Adicionar ao Google Calendar</a>
      </div>
      <p style="color:#666;font-size:14px;line-height:1.6">Se precisar de cancelar ou alterar a sua marcação, entre em contacto connosco com pelo menos 24 horas de antecedência.</p>
    </div>
    <div class="footer">
      <p><strong>{nomeNegocio}</strong></p>
      <p>Até breve!</p>
    </div>
  </div>
</body>
</html>`

const TEMPLATE_LEMBRETE_PADRAO = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style>
    body{font-family:'Jost',system-ui,sans-serif;font-weight:300;background:#faf7f5;margin:0;padding:0}
    .container{max-width:560px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.08)}
    .header{background:#8B4A2F;padding:36px 40px;text-align:center}
    .header h1{color:#fff;margin:0;font-size:26px;letter-spacing:3px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .header p{color:#e8d5c8;margin:8px 0 0;font-size:12px;letter-spacing:.08em;font-weight:300;font-family:'Jost',sans-serif}
    .body{padding:36px 40px}
    .greeting{font-size:20px;color:#333;margin-bottom:8px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .body p{font-family:'Jost',sans-serif;font-weight:300}
    .details{background:#faf7f5;border-radius:8px;padding:24px;margin:24px 0}
    .detail-row{margin-bottom:16px}.detail-row:last-child{margin-bottom:0}
    .detail-label{font-size:11px;color:#999;text-transform:uppercase;letter-spacing:.12em;margin-bottom:2px;font-weight:600;font-family:'Jost',sans-serif}
    .detail-value{font-size:15px;color:#333;font-weight:500;font-family:'Jost',sans-serif}
    .footer{background:#faf7f5;padding:24px 40px;text-align:center;border-top:1px solid #f0ebe7}
    .footer p{color:#999;font-size:12px;margin:4px 0;font-weight:300;font-family:'Jost',sans-serif}
    @media(max-width:600px){.container{margin:0;border-radius:0}.body{padding:24px 20px}.header{padding:28px 20px}}
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>{nomeNegocio}</h1>
      <p>Lembrete de Agendamento</p>
    </div>
    <div class="body">
      <p class="greeting">Olá, {nomeCompleto}!</p>
      <p style="color:#666;line-height:1.6">Lembramos que tem uma marcação agendada. Aguardamos a sua visita!</p>
      <div class="details">
        <div class="detail-row"><div><div class="detail-label">Serviço</div><div class="detail-value">{servico}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Profissional</div><div class="detail-value">{profissional}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Data</div><div class="detail-value">{data}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Hora</div><div class="detail-value">{hora} – {horaFim}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Morada</div><div class="detail-value">{morada}</div></div></div>
        <div class="detail-row"><div><div class="detail-label">Contacto</div><div class="detail-value">{telefone}</div></div></div>
      </div>
      <p style="color:#666;font-size:14px;line-height:1.6">Se precisar de cancelar ou alterar a sua marcação, entre em contacto connosco com pelo menos 24 horas de antecedência.</p>
    </div>
    <div class="footer">
      <p><strong>{nomeNegocio}</strong></p>
      <p>Até breve!</p>
    </div>
  </div>
</body>
</html>`

const TEMPLATE_ANIVERSARIO_PADRAO = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style>
    body{font-family:'Jost',system-ui,sans-serif;font-weight:300;background:#faf7f5;margin:0;padding:0}
    .container{max-width:560px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,.08)}
    .header{background:#8B4A2F;padding:36px 40px;text-align:center}
    .header h1{color:#fff;margin:0;font-size:26px;letter-spacing:3px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .header p{color:#e8d5c8;margin:8px 0 0;font-size:12px;letter-spacing:.08em;font-weight:300;font-family:'Jost',sans-serif}
    .body{padding:36px 40px}
    .greeting{font-size:20px;color:#333;margin-bottom:8px;font-weight:300;font-family:'Cormorant Garamond',Georgia,serif}
    .body p{font-family:'Jost',sans-serif;font-weight:300}
    .footer{background:#faf7f5;padding:24px 40px;text-align:center;border-top:1px solid #f0ebe7}
    .footer p{color:#999;font-size:12px;margin:4px 0;font-weight:300;font-family:'Jost',sans-serif}
    @media(max-width:600px){.container{margin:0;border-radius:0}.body{padding:24px 20px}.header{padding:28px 20px}}
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>{nomeNegocio}</h1>
      <p>Feliz Aniversário</p>
    </div>
    <div class="body">
      <p class="greeting">Feliz aniversário, {nome}!</p>
      <p style="color:#666;line-height:1.6">A toda a equipa de <strong>{nomeNegocio}</strong> deseja-lhe um dia muito especial cheio de alegria.</p>
      <p style="color:#666;line-height:1.6">Será sempre um prazer recebê-la e esperamos vê-la em breve!</p>
    </div>
    <div class="footer">
      <p><strong>{nomeNegocio}</strong></p>
      <p>Com os melhores cumprimentos</p>
    </div>
  </div>
</body>
</html>`

function aplicarDummy(tpl) {
  return (tpl || '').replace(/\{(\w+)\}/g, (_, key) => DUMMY[key] ?? `{${key}}`)
}

function ModalPreview({ html, onFechar }) {
  return (
    <div
      onClick={onFechar}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 'var(--raio-lg)', width: '100%', maxWidth: '620px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--cor-borda)' }}>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Pré-visualização do email (dados fictícios)</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'var(--cor-texto-suave)', lineHeight: 1 }}>×</button>
        </div>
        <iframe
          srcDoc={html}
          title="Preview do email"
          style={{ flex: 1, border: 'none', minHeight: '500px' }}
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  )
}

function AssuntoInput({ valor, onChange, tags, disabled, placeholder }) {
  const ref = useRef(null)
  function inserirTag(tag) {
    const el = ref.current
    if (!el) { onChange((valor || '') + tag); return }
    const start = el.selectionStart
    const end = el.selectionEnd
    const novo = (valor || '').slice(0, start) + tag + (valor || '').slice(end)
    onChange(novo)
    setTimeout(() => { el.focus(); el.setSelectionRange(start + tag.length, start + tag.length) }, 0)
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <input
        ref={ref}
        type="text"
        value={valor || ''}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        style={{ ...inputStyle, width: '100%' }}
        placeholder={placeholder}
      />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {tags.map(tag => (
          <button
            key={tag}
            type="button"
            disabled={disabled}
            onClick={() => inserirTag(tag)}
            style={{ padding: '3px 10px', fontSize: '12px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-principal)', background: 'transparent', color: 'var(--cor-principal)', cursor: disabled ? 'not-allowed' : 'pointer', fontFamily: 'var(--font-ui)', opacity: disabled ? 0.4 : 1 }}
          >
            {tag}
          </button>
        ))}
      </div>
    </div>
  )
}

function MensagemHtmlTextarea({ valor, onChange, placeholder, nomeNegocio, tags = ['{nome}', '{servico}', '{data}', '{hora}'], isTemplate = false }) {
  const [preview, setPreview] = useState(false)

  const htmlPreview = isTemplate
    ? aplicarDummy(valor || TEMPLATE_PADRAO)
    : aplicarDummy(valor)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {tags.map(tag => (
            <button
              key={tag}
              type="button"
              onClick={() => onChange((valor || '') + tag)}
              style={{ padding: '3px 10px', fontSize: '12px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-principal)', background: 'transparent', color: 'var(--cor-principal)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}
            >
              {tag}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={() => setPreview(true)}
          style={{ padding: '4px 14px', fontSize: '12px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo)', color: 'var(--cor-texto)', cursor: 'pointer', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}
        >
          Pré-visualizar
        </button>
      </div>
      <textarea
        value={valor}
        onChange={e => onChange(e.target.value)}
        rows={8}
        style={{ ...inputStyle, width: '100%', resize: 'vertical', fontFamily: 'monospace', fontSize: '13px' }}
        placeholder={placeholder}
        spellCheck={false}
      />
      {preview && <ModalPreview html={htmlPreview} onFechar={() => setPreview(false)} />}
    </div>
  )
}

export default function ConfiguracoesSuperAdmin() {
  const { tenant } = useTenant()
  const { perfil } = useAuth()
  const toast = useToast()
  const perfilNome = perfil?.nome || perfil?.email || 'backoffice'
  const [cfg, setCfg] = useState(null)
  const [guardando, setGuardando] = useState(false)
  const [emailTeste, setEmailTeste] = useState('')
  const [enviandoTeste, setEnviandoTeste] = useState(false)
  const [emailTesteLembrete, setEmailTesteLembrete] = useState('')
  const [enviandoTesteLembrete, setEnviandoTesteLembrete] = useState(false)
  const [emailTesteAniversario, setEmailTesteAniversario] = useState('')
  const [enviandoTesteAniversario, setEnviandoTesteAniversario] = useState(false)
  // Stripe Connect: { ligado, completo } | null (a carregar)
  const [connect, setConnect] = useState(null)
  const [ligandoStripe, setLigandoStripe] = useState(false)
  // Vendus: { ligado } | null (a carregar)
  const [vendus, setVendus] = useState(null)
  const [vendusKey, setVendusKey] = useState('')        // campo de input (não persiste a key)
  const [guardandoVendus, setGuardandoVendus] = useState(false)
  const [testandoVendus, setTestandoVendus] = useState(false)
  // Meios de pagamento da conta Vendus (para associação) + estado do botão
  const [metodosVendus, setMetodosVendus] = useState(null)   // [{id,title,type}] | null
  const [sincroVendus, setSincroVendus] = useState(false)
  // Tipos de pagamento do salão (dinheiro/multibanco/…) — campo do novo método
  const [novoMetodoLabel, setNovoMetodoLabel] = useState('')

  // Marcar pagamentos antigos como pagos (carregamento em massa de agendamentos importados)
  const [mpDataInicio, setMpDataInicio] = useState('')
  const [mpDataFim, setMpDataFim] = useState('')
  const [mpOrigem, setMpOrigem] = useState('importado') // 'importado' | 'outro'
  const [mpOutro, setMpOutro] = useState('')
  const [mpPreview, setMpPreview] = useState(null) // { grupos, nAgendamentos, nClientes, total } | null
  const [mpAPreVisualizar, setMpAPreVisualizar] = useState(false)
  const [mpAConfirmar, setMpAConfirmar] = useState(false)
  const [mpResultado, setMpResultado] = useState(null)

  useEffect(() => {
    if (!tenant) return
    getConfiguracoes(tenant.id)
      .then(data => setCfg({ fuso_horario: 'Europe/Lisbon', ...data }))
      .catch(e => toast.erro(e.message))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])

  // Estado da ligação Stripe Connect. Ao regressar do onboarding (?stripe_return=1)
  // consulta o Stripe (charges_enabled); caso contrário lê só da BD.
  useEffect(() => {
    if (!tenant) return
    const params = new URLSearchParams(window.location.search)
    const regressou = params.get('stripe_return') === '1'
    const fn = regressou ? stripeConnectAtualizarEstado : stripeConnectEstado
    fn(tenant.id)
      .then(setConnect)
      .catch(() => setConnect({ ligado: false, completo: false }))
    if (regressou || params.get('stripe_refresh')) {
      // limpa os query params para não reconsultar em refreshes
      window.history.replaceState({}, '', window.location.pathname)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])

  async function ligarStripe() {
    setLigandoStripe(true)
    try {
      const url = await stripeConnectLink(tenant.id)
      window.location.href = url
    } catch (err) {
      toast.erro(err.message)
      setLigandoStripe(false)
    }
  }

  // Estado da ligação Vendus (flag, sem expor a key).
  useEffect(() => {
    if (!tenant) return
    vendusEstado(tenant.id)
      .then(setVendus)
      .catch(() => setVendus({ ligado: false }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])

  async function guardarVendusKey() {
    setGuardandoVendus(true)
    try {
      const r = await vendusGuardarKey(tenant.id, vendusKey)
      setVendus({ ligado: !!r.ligado })
      setVendusKey('')
      toast.sucesso(r.ligado ? 'Chave Vendus guardada.' : 'Chave Vendus removida.')
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setGuardandoVendus(false)
    }
  }

  async function testarVendus() {
    setTestandoVendus(true)
    try {
      const r = await vendusTestar(tenant.id)
      if (r.ok) toast.sucesso('Ligação Vendus OK.')
      else toast.erro(r.detalhe || r.error || 'Falha na ligação Vendus.')
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setTestandoVendus(false)
    }
  }

  // Vai buscar os meios de pagamento da conta Vendus para os associar aos
  // métodos internos. Não persiste nada — a associação é guardada no "Guardar".
  async function sincronizarMetodosVendus() {
    setSincroVendus(true)
    try {
      const r = await vendusMetodosPagamento(tenant.id)
      if (r.ok) {
        setMetodosVendus(r.metodos || [])
        toast.sucesso(`${(r.metodos || []).length} meio(s) de pagamento carregados. Associe e clique em Guardar.`)
      } else {
        toast.erro(r.error || 'Falha ao obter meios de pagamento.')
      }
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setSincroVendus(false)
    }
  }

  // Lê o mapa {metodo_interno: vendus_id} guardado em cfg.vendus_metodos_map.
  function metodosMap() {
    try { return JSON.parse(cfg.vendus_metodos_map || '{}') } catch { return {} }
  }

  // Associa um método interno a um id de meio de pagamento Vendus (ou remove).
  function setMetodoMap(chaveInterna, vendusId) {
    const mapa = metodosMap()
    if (vendusId === '') delete mapa[chaveInterna]
    else mapa[chaveInterna] = Number(vendusId)
    set('vendus_metodos_map', JSON.stringify(mapa))
  }

  // Tipos de pagamento do salão (dinheiro/multibanco/…), configuráveis aqui.
  // Guardados em cfg.metodos_pagamento (JSON); parseMetodosPagamento cai para
  // a lista por defeito enquanto o tenant não tiver guardado nada.
  function metodosPagamento() {
    return parseMetodosPagamento(cfg)
  }

  // A chave é gerada uma vez a partir do rótulo e nunca muda depois — fica
  // gravada em agendamentos.sinal_metodo/restante_metodo, por isso renomear
  // só altera o rótulo, não a chave.
  function adicionarMetodo() {
    const label = novoMetodoLabel.trim()
    if (!label) return
    const atuais = metodosPagamento()
    let chave = slugifyMetodo(label)
    if (!chave || chave === METODO_STRIPE || atuais.some(m => m.chave === chave)) {
      toast.erro('Já existe um método com um nome equivalente.')
      return
    }
    set('metodos_pagamento', JSON.stringify([...atuais, { chave, label }]))
    setNovoMetodoLabel('')
  }

  function renomearMetodo(chave, novoLabel) {
    set('metodos_pagamento', JSON.stringify(metodosPagamento().map(m => m.chave === chave ? { ...m, label: novoLabel } : m)))
  }

  // Remove da lista de escolha (não apaga o histórico: marcações antigas com
  // esta chave continuam a mostrá-la, só deixa de aparecer nas opções novas).
  // Limpa também a associação Vendus desse método, se existir.
  function removerMetodo(chave) {
    const atuais = metodosPagamento()
    if (atuais.length <= 1) {
      toast.erro('Tem de existir pelo menos um método de pagamento.')
      return
    }
    set('metodos_pagamento', JSON.stringify(atuais.filter(m => m.chave !== chave)))
    const mapa = metodosMap()
    if (mapa[chave] != null) {
      delete mapa[chave]
      set('vendus_metodos_map', JSON.stringify(mapa))
    }
  }

  function set(chave, valor) {
    setCfg(prev => ({ ...prev, [chave]: valor }))
  }

  async function enviarTeste(e) {
    e.preventDefault()
    if (!emailTeste) return
    setEnviandoTeste(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/agendamentos_test_email`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session?.access_token}`,
          },
          body: JSON.stringify({ email_destino: emailTeste, tenant_id: tenant.id }),
        }
      )
      const data = await res.json()
      if (data.sucesso) {
        toast.sucesso(`Email de teste enviado para ${emailTeste}`)
      } else {
        toast.erro(data.erro || 'Erro ao enviar email de teste')
      }
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setEnviandoTeste(false)
    }
  }

  async function enviarTesteLembrete(e) {
    e.preventDefault()
    if (!emailTesteLembrete) return
    setEnviandoTesteLembrete(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/agendamentos_test_email`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
          body: JSON.stringify({ email_destino: emailTesteLembrete, tenant_id: tenant.id, tipo: 'lembrete' }),
        }
      )
      const data = await res.json()
      if (data.sucesso) toast.sucesso(`Email de teste enviado para ${emailTesteLembrete}`)
      else toast.erro(data.erro || 'Erro ao enviar email de teste')
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setEnviandoTesteLembrete(false)
    }
  }

  async function enviarTesteAniversario(e) {
    e.preventDefault()
    if (!emailTesteAniversario) return
    setEnviandoTesteAniversario(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/agendamentos_test_email`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
          body: JSON.stringify({ email_destino: emailTesteAniversario, tenant_id: tenant.id, tipo: 'aniversario' }),
        }
      )
      const data = await res.json()
      if (data.sucesso) toast.sucesso(`Email de teste enviado para ${emailTesteAniversario}`)
      else toast.erro(data.erro || 'Erro ao enviar email de teste')
    } catch (err) {
      toast.erro(err.message)
    } finally {
      setEnviandoTesteAniversario(false)
    }
  }

  // Motivo/origem gravado em pagamentos.metodo para estas marcações em massa —
  // "Importado" fixo ou um texto livre ("Outro"), nunca os métodos reais do
  // salão (dinheiro/mbway/…), para se distinguirem em auditorias futuras.
  function mpMetodoFinal() {
    return mpOrigem === 'outro' ? mpOutro.trim() : 'Importado'
  }

  // Pré-visualização: procura, em todo o tenant, os agendamentos no intervalo
  // com parcelas por pagar (sinal e/ou restante — respeita o que já estava
  // pago) e agrupa-os por cliente, tal como o "Cobrar em conjunto" precisa de
  // um cliente por lote (RPC criar_cobranca).
  async function preverPagamentosImportados() {
    if (!mpDataFim) { toast.erro('Indica a data de fim.'); return }
    setMpAPreVisualizar(true)
    setMpPreview(null)
    setMpResultado(null)
    try {
      const inicioISO = mpDataInicio ? new Date(mpDataInicio + 'T00:00:00').toISOString() : null
      const fimISO = new Date(mpDataFim + 'T23:59:59').toISOString()
      const { agendamentos, pagamentos } = await getAgendamentosParaMarcarPagos(tenant.id, inicioISO, fimISO)

      const porCliente = new Map()
      for (const ag of agendamentos) {
        // O restante de uma marcação ainda futura só se cobra depois do serviço
        // (mesma regra do "Cobrar em conjunto") — nunca se marca como pago aqui.
        const futuro = new Date(ag.data_hora_inicio).getTime() > Date.now()
        const sinalEsp = sinalEsperadoImportado(ag, cfg)
        const est = estadoParcelas(ag, pagamentos, { sinalEsperado: sinalEsp })
        const itensAg = []
        if (!est.sinal.pago && Number(est.sinal.valorSugerido) > 0) {
          itensAg.push({ agendamento_id: ag.id, tipo: 'sinal', descricao: 'Sinal (importado)', valor: Number(Number(est.sinal.valorSugerido).toFixed(2)) })
        }
        if (!futuro && !est.restante.pago && Number(est.restante.valorSugerido) > 0) {
          itensAg.push({ agendamento_id: ag.id, tipo: 'restante', descricao: 'Restante (importado)', valor: Number(Number(est.restante.valorSugerido).toFixed(2)) })
        }
        if (itensAg.length === 0) continue

        const chave = ag.cliente_id || `sem-cliente:${ag.cliente_nome || ''}`
        if (!porCliente.has(chave)) {
          porCliente.set(chave, { clienteId: ag.cliente_id || null, clienteNome: ag.cliente_nome || 'Sem cliente', agendamentoIds: new Set(), itens: [], total: 0 })
        }
        const grupo = porCliente.get(chave)
        for (const it of itensAg) { grupo.itens.push(it); grupo.total += it.valor; grupo.agendamentoIds.add(ag.id) }
      }

      const grupos = Array.from(porCliente.values())
      const nAgendamentos = new Set(grupos.flatMap(g => Array.from(g.agendamentoIds))).size
      const total = grupos.reduce((s, g) => s + g.total, 0)
      setMpPreview({ grupos, nAgendamentos, nClientes: grupos.length, total })
      if (grupos.length === 0) toast.sucesso('Não há nada por marcar como pago neste intervalo.')
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setMpAPreVisualizar(false)
    }
  }

  // Confirmação: cria uma cobrança (RPC criar_cobranca) por cliente, cada uma
  // com todas as parcelas por pagar desse cliente no intervalo — mesma lógica
  // atómica e idempotente do "Cobrar em conjunto", só que corrida em lote.
  async function confirmarPagamentosImportados() {
    if (!mpPreview || mpPreview.grupos.length === 0) return
    const metodo = mpMetodoFinal()
    if (!metodo) { toast.erro('Indica o motivo (escolhe "Outro" e escreve um texto, ou usa "Importado").'); return }
    setMpAConfirmar(true)
    try {
      let nParcelas = 0
      for (const g of mpPreview.grupos) {
        await criarCobranca(tenant.id, { clienteId: g.clienteId, clienteNome: g.clienteNome, metodo, itens: g.itens }, perfilNome)
        nParcelas += g.itens.length
      }
      toast.sucesso(`${mpPreview.nClientes} ${mpPreview.nClientes === 1 ? 'cliente' : 'clientes'} · ${nParcelas} ${nParcelas === 1 ? 'parcela marcada' : 'parcelas marcadas'} como paga${nParcelas === 1 ? '' : 's'}.`)
      setMpResultado({ nClientes: mpPreview.nClientes, nParcelas, total: mpPreview.total })
      setMpPreview(null)
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setMpAConfirmar(false)
    }
  }

  async function guardar(e) {
    e.preventDefault()
    setGuardando(true)
    try {
      const campos = [
        'paginacao_tamanho',
        'booking_rate_ativo', 'booking_rate_max', 'booking_rate_janela_min',
        'stripe_ativo', 'stripe_sinal_percentagem',
        'vendus_ativo', 'vendus_documento_defeito', 'vendus_modo_teste', 'vendus_metodos_map', 'vendus_dominio',
        'metodos_pagamento',
        'email_from', 'email_bcc', 'fuso_horario',
        'email_confirmacao_ativo', 'email_assunto', 'email_template_html',
        'email_lembrete_ativo', 'email_lembrete_hora', 'email_lembrete_dias_antes', 'email_lembrete_assunto', 'email_lembrete_mensagem',
        'aniversario_email_ativo', 'aniversario_email_hora', 'aniversario_email_assunto', 'aniversario_email_mensagem',
      ]
      await Promise.all(campos.map(c => updateConfiguracao(tenant.id, c, cfg[c] || '')))
      toast.sucesso('Configurações guardadas com sucesso.')
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setGuardando(false)
    }
  }

  if (!cfg) return <div style={{ padding: '64px 24px' }}><Loading /></div>

  return (
    <div style={{ maxWidth: '620px', margin: '0 auto', padding: '32px 24px 64px' }}>
      <h2 style={{ marginBottom: '6px', fontSize: '22px' }}>Config Admin</h2>
      <p style={{ color: 'var(--cor-texto-suave)', marginBottom: '32px', fontSize: '14px' }}>
        Definições avançadas, apenas acessíveis a super administradores.
      </p>

      <form onSubmit={guardar}>
        <Secao titulo="Paginação">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Número de linhas por página nas listagens do backoffice (Clientes, detalhe dos Relatórios…).
          </p>
          <Campo label="Linhas por página">
            <input
              type="number" min="5" max="200" step="1"
              value={cfg.paginacao_tamanho || ''}
              onChange={e => set('paginacao_tamanho', e.target.value)}
              style={{ ...inputStyle, width: '140px' }} placeholder="20"
            />
          </Campo>
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '10px' }}>
            Por defeito: 20 linhas. Deixa em branco para usar o valor por defeito.
          </p>
        </Secao>

        <Secao titulo="Agendamento Online — Limite por Visitante">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Limita quantas marcações o mesmo visitante (IP) pode fazer no site dentro de um período, para evitar spam.
          </p>

          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
            <input
              type="checkbox"
              checked={cfg.booking_rate_ativo !== 'false'}
              onChange={e => set('booking_rate_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span>Limitar marcações por visitante</span>
          </label>

          {cfg.booking_rate_ativo !== 'false' && (
            <>
              <div className="grid-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginTop: '12px' }}>
                <Campo label="Máximo de marcações">
                  <input
                    type="number" min="1" max="100" step="1"
                    value={cfg.booking_rate_max || ''}
                    onChange={e => set('booking_rate_max', e.target.value)}
                    style={{ ...inputStyle, width: '100%' }} placeholder="5"
                  />
                </Campo>
                <Campo label="Por período (horas)">
                  <input
                    type="number" min="1" max="168" step="1"
                    value={cfg.booking_rate_janela_min ? Math.round(Number(cfg.booking_rate_janela_min) / 60) : ''}
                    onChange={e => set('booking_rate_janela_min', e.target.value ? String(Math.round(Number(e.target.value) * 60)) : '')}
                    style={{ ...inputStyle, width: '100%' }} placeholder="1"
                  />
                </Campo>
              </div>
              <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '10px' }}>
                Por defeito: 5 marcações por hora. Deixa em branco para usar o valor por defeito.
              </p>
            </>
          )}
        </Secao>

        <Secao titulo="Pagamentos (Stripe)">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Com o Stripe activo, o cliente paga um sinal online antes de a marcação ser confirmada
            (e antes do envio de emails). Desactivado, as marcações seguem sem pagamento.
          </p>

          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
            <input
              type="checkbox"
              checked={cfg.stripe_ativo === 'true'}
              onChange={e => set('stripe_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span>Exigir pagamento de sinal (Stripe)</span>
          </label>

          {cfg.stripe_ativo === 'true' && (
            <>
              {/* Ligação da conta Stripe do salão (Connect) */}
              <div style={{ marginTop: '16px', padding: '14px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo, #faf9f8)' }}>
                {connect === null ? (
                  <p style={{ fontSize: '13px', color: 'var(--cor-texto-suave)', margin: 0 }}>A verificar ligação Stripe…</p>
                ) : connect.completo ? (
                  <p style={{ fontSize: '13px', margin: 0, color: '#15803D', fontWeight: 500 }}>
                    ✓ Conta Stripe deste salão ligada e pronta a receber pagamentos.
                  </p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <p style={{ fontSize: '13px', margin: 0, color: connect.ligado ? '#B45309' : 'var(--cor-texto-suave)' }}>
                      {connect.ligado
                        ? '⚠ Onboarding Stripe incompleto. Continue para o salão poder receber pagamentos.'
                        : 'O salão ainda não tem conta Stripe ligada. Ligue para que o dinheiro do sinal vá directamente para a conta bancária do salão.'}
                    </p>
                    <button
                      type="button"
                      onClick={ligarStripe}
                      disabled={ligandoStripe}
                      className="btn-primario"
                      style={{ alignSelf: 'flex-start', padding: '9px 16px', opacity: ligandoStripe ? 0.6 : 1 }}
                    >
                      {ligandoStripe ? 'A abrir Stripe…' : (connect.ligado ? 'Continuar onboarding Stripe' : 'Ligar conta Stripe do salão')}
                    </button>
                  </div>
                )}
              </div>

              <div className="grid-2col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginTop: '12px' }}>
                <Campo label="Percentagem base do sinal (%)">
                  <input
                    type="number" min="1" max="100" step="1"
                    value={cfg.stripe_sinal_percentagem || ''}
                    onChange={e => set('stripe_sinal_percentagem', e.target.value)}
                    style={{ ...inputStyle, width: '100%' }} placeholder="50"
                  />
                </Campo>
              </div>
              <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '10px' }}>
                Aplica-se ao preço do serviço. Cada serviço pode definir um sinal fixo (€) que sobrepõe esta percentagem.
                O sinal é cobrado directamente na conta Stripe do salão (recebe 100%).
              </p>
            </>
          )}
        </Secao>

        <Secao titulo="Tipos de pagamento">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Métodos disponíveis para liquidar o sinal e o restante no salão (Nova Marcação, ficha da
            marcação e Cobrar em conjunto). Remover um método não apaga o histórico — marcações antigas
            continuam a mostrar o método usado na altura, mesmo que deixe de ser uma opção nova.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' }}>
            {metodosPagamento().map(m => (
              <div key={m.chave} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  value={m.label}
                  onChange={e => renomearMetodo(m.chave, e.target.value)}
                  style={{ ...inputStyle, flex: 1 }}
                />
                <button
                  type="button"
                  onClick={() => removerMetodo(m.chave)}
                  style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', padding: '8px 12px', fontSize: '13px', color: '#B91C1C', cursor: 'pointer' }}
                >
                  Remover
                </button>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              value={novoMetodoLabel}
              onChange={e => setNovoMetodoLabel(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); adicionarMetodo() } }}
              placeholder="Novo método (ex: Cheque)"
              style={{ ...inputStyle, flex: 1 }}
            />
            <button type="button" onClick={adicionarMetodo} className="btn-secundario" style={{ padding: '9px 16px' }}>
              Adicionar
            </button>
          </div>
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '10px' }}>
            As alterações só ficam gravadas depois de clicar em "Guardar" no fundo da página.
          </p>
        </Secao>

        <Secao titulo="Marcar pagamentos antigos como pagos">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Para agendamentos antigos carregados em massa (de outra aplicação): marca como pago
            tudo o que estiver por saldar (sinal e/ou restante) até uma data-limite. Respeita o que já
            estava pago — não duplica nem sobrepõe. Esta ação é imediata e não depende do botão
            "Guardar" no fundo da página.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            <Campo label="Data de início (opcional)">
              <input
                type="date"
                value={mpDataInicio}
                onChange={e => { setMpDataInicio(e.target.value); setMpPreview(null); setMpResultado(null) }}
                style={{ ...inputStyle, width: '100%' }}
              />
            </Campo>
            <Campo label="Data de fim">
              <input
                type="date"
                value={mpDataFim}
                onChange={e => { setMpDataFim(e.target.value); setMpPreview(null); setMpResultado(null) }}
                style={{ ...inputStyle, width: '100%' }}
              />
            </Campo>
          </div>
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '8px' }}>
            Deixa a data de início em branco para aplicar a todos os agendamentos até à data de fim.
          </p>

          <div style={{ marginTop: '14px' }}>
            <Campo label="Motivo">
              <select
                value={mpOrigem}
                onChange={e => { setMpOrigem(e.target.value); setMpPreview(null); setMpResultado(null) }}
                style={{ ...inputStyle, width: '100%' }}
              >
                <option value="importado">Importado</option>
                <option value="outro">Outro</option>
              </select>
            </Campo>
            {mpOrigem === 'outro' && (
              <input
                type="text" value={mpOutro}
                onChange={e => { setMpOutro(e.target.value); setMpPreview(null); setMpResultado(null) }}
                maxLength={60} placeholder="Descreve o motivo…"
                style={{ ...inputStyle, width: '100%', marginTop: '8px' }}
              />
            )}
          </div>

          <button
            type="button"
            onClick={preverPagamentosImportados}
            disabled={mpAPreVisualizar || !mpDataFim}
            className="btn-secundario"
            style={{ marginTop: '16px', padding: '9px 16px', opacity: (mpAPreVisualizar || !mpDataFim) ? 0.6 : 1 }}
          >
            {mpAPreVisualizar ? 'A analisar…' : 'Pré-visualizar'}
          </button>

          {mpPreview && mpPreview.grupos.length > 0 && (
            <div style={{ marginTop: '16px', padding: '14px 16px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-creme)' }}>
              <p style={{ fontSize: '14px', margin: '0 0 10px' }}>
                Vão ficar marcadas como pagas <strong>{mpPreview.nAgendamentos}</strong> {mpPreview.nAgendamentos === 1 ? 'marcação' : 'marcações'} de{' '}
                <strong>{mpPreview.nClientes}</strong> {mpPreview.nClientes === 1 ? 'cliente' : 'clientes'}, no total de <strong>{fmtEur(mpPreview.total)}</strong> — motivo "{mpMetodoFinal() || '—'}".
              </p>
              <button
                type="button"
                onClick={confirmarPagamentosImportados}
                disabled={mpAConfirmar || (mpOrigem === 'outro' && !mpOutro.trim())}
                className="btn-primario"
                style={{ padding: '9px 16px', opacity: (mpAConfirmar || (mpOrigem === 'outro' && !mpOutro.trim())) ? 0.6 : 1 }}
              >
                {mpAConfirmar ? 'A marcar…' : `Confirmar e marcar como pago (${fmtEur(mpPreview.total)})`}
              </button>
            </div>
          )}

          {mpResultado && (
            <div style={{ marginTop: '16px', padding: '14px 16px', borderRadius: 'var(--raio)', background: '#E6F0E9', border: '1px solid #B7D3C0', color: '#166534', fontSize: '13px' }}>
              ✓ {mpResultado.nClientes} {mpResultado.nClientes === 1 ? 'cliente' : 'clientes'} · {mpResultado.nParcelas} {mpResultado.nParcelas === 1 ? 'parcela marcada' : 'parcelas marcadas'} como paga{mpResultado.nParcelas === 1 ? '' : 's'} — total {fmtEur(mpResultado.total)}.
            </div>
          )}
        </Secao>

        <Secao titulo="Faturação (Vendus)">
          <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginTop: '-4px', marginBottom: '14px' }}>
            Com a faturação activa, é possível emitir o documento fiscal do valor pago no salão
            directamente na conta Vendus deste salão. O tipo de documento sobe automaticamente
            para Fatura-Recibo quando o cliente tem NIF ou o valor excede 1000&nbsp;€.
          </p>

          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px' }}>
            <input
              type="checkbox"
              checked={cfg.vendus_ativo === 'true'}
              onChange={e => set('vendus_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span>Emitir faturas (Vendus)</span>
          </label>

          {cfg.vendus_ativo === 'true' && (
            <>
              {/* Estado da ligação à conta Vendus do salão */}
              <div style={{ marginTop: '16px', padding: '14px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo, #faf9f8)' }}>
                {vendus === null ? (
                  <p style={{ fontSize: '13px', color: 'var(--cor-texto-suave)', margin: 0 }}>A verificar ligação Vendus…</p>
                ) : vendus.ligado ? (
                  <p style={{ fontSize: '13px', margin: 0, color: '#15803D', fontWeight: 500 }}>
                    ✓ Conta Vendus deste salão ligada.
                  </p>
                ) : (
                  <p style={{ fontSize: '13px', margin: 0, color: 'var(--cor-texto-suave)' }}>
                    A conta Vendus ainda não está ligada. Cole a API key abaixo para activar a faturação.
                  </p>
                )}
              </div>

              <div style={{ marginTop: '16px' }}>
                <Campo label={vendus?.ligado ? 'Substituir API key Vendus (deixe vazio para manter)' : 'API key Vendus'}>
                  <input
                    type="password"
                    autoComplete="off"
                    value={vendusKey}
                    onChange={e => setVendusKey(e.target.value)}
                    placeholder={vendus?.ligado ? '•••••••• (key guardada)' : 'Cole aqui a API key da conta Vendus'}
                    style={{ ...inputStyle, width: '100%' }}
                  />
                </Campo>
                <div style={{ display: 'flex', gap: '10px', marginTop: '10px', flexWrap: 'wrap' }}>
                  <button
                    type="button"
                    onClick={guardarVendusKey}
                    disabled={guardandoVendus || (!vendusKey && !vendus?.ligado)}
                    className="btn-primario"
                    style={{ padding: '9px 16px', opacity: guardandoVendus ? 0.6 : 1 }}
                  >
                    {guardandoVendus ? 'A guardar…' : 'Guardar chave'}
                  </button>
                  <button
                    type="button"
                    onClick={testarVendus}
                    disabled={testandoVendus || !vendus?.ligado}
                    className="btn-secundario"
                    style={{ padding: '9px 16px', opacity: (testandoVendus || !vendus?.ligado) ? 0.6 : 1 }}
                  >
                    {testandoVendus ? 'A testar…' : 'Testar ligação'}
                  </button>
                  <button
                    type="button"
                    onClick={sincronizarMetodosVendus}
                    disabled={sincroVendus || !vendus?.ligado}
                    className="btn-secundario"
                    style={{ padding: '9px 16px', opacity: (sincroVendus || !vendus?.ligado) ? 0.6 : 1 }}
                  >
                    {sincroVendus ? 'A sincronizar…' : 'Sincronizar meios de pagamento'}
                  </button>
                </div>
                <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '8px' }}>
                  A chave é guardada em segredo e nunca é mostrada novamente.
                </p>
              </div>

              {/* Associação dos métodos internos aos meios de pagamento Vendus.
                  Só aparece depois de sincronizar (ou se já houver mapa guardado). */}
              {(metodosVendus || cfg.vendus_metodos_map) && (
                <div style={{ marginTop: '16px', padding: '14px', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', background: 'var(--cor-fundo-suave, #fafafa)' }}>
                  <p style={{ fontWeight: 600, fontSize: '14px', margin: '0 0 4px' }}>Meios de pagamento</p>
                  <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', margin: '0 0 12px' }}>
                    Associe cada método de pagamento do salão ao meio correspondente na conta Vendus.
                    Métodos sem associação saem na fatura sem meio de pagamento discriminado.
                    {!metodosVendus && ' Clique em “Sincronizar meios de pagamento” para atualizar a lista.'}
                  </p>
                  {/* Métodos liquidados no salão + o meio exclusivo do sinal
                      (Stripe). A chave interna 'stripe' é reservada: quando uma
                      marcação tem sinal pago online, essa parcela sai na fatura
                      no meio aqui associado, e o restante no meio do método
                      escolhido no salão. */}
                  {[...metodosPagamento(), { chave: METODO_STRIPE, label: 'Sinal (Stripe)' }].map(m => {
                    const idAtual = metodosMap()[m.chave]
                    return (
                      <div key={m.chave} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                        <span style={{ flex: '0 0 110px', fontSize: '13px' }}>{m.label}</span>
                        <select
                          value={idAtual != null ? String(idAtual) : ''}
                          onChange={e => setMetodoMap(m.chave, e.target.value)}
                          style={{ ...inputStyle, flex: 1 }}
                        >
                          <option value="">— sem associação —</option>
                          {/* Opções conhecidas: da última sincronização; se ainda não
                              sincronizou mas há id guardado, mostra-o como fallback. */}
                          {(metodosVendus || []).map(mp => (
                            <option key={mp.id} value={String(mp.id)}>{mp.title} ({mp.type})</option>
                          ))}
                          {!metodosVendus && idAtual != null && (
                            <option value={String(idAtual)}>id {idAtual} (guardado)</option>
                          )}
                        </select>
                      </div>
                    )
                  })}
                  <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', margin: '8px 0 0' }}>
                    O meio <strong>Sinal (Stripe)</strong> é usado para a parcela do sinal pago online.
                    Quando o sinal é superior a zero, a fatura sai com dois pagamentos:
                    o sinal neste meio e o restante no meio do método escolhido.
                  </p>
                </div>
              )}

              <div style={{ marginTop: '16px' }}>
                <Campo label="Documento por defeito">
                  <select
                    value={cfg.vendus_documento_defeito || 'FS'}
                    onChange={e => set('vendus_documento_defeito', e.target.value)}
                    style={{ ...inputStyle, width: '100%' }}
                  >
                    <option value="FS">Fatura Simplificada (FS)</option>
                    <option value="FR">Fatura-Recibo (FR)</option>
                  </select>
                </Campo>
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '14px', marginTop: '16px' }}>
                <input
                  type="checkbox"
                  checked={cfg.vendus_modo_teste === 'true'}
                  onChange={e => set('vendus_modo_teste', e.target.checked ? 'true' : 'false')}
                  style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
                />
                <span>Modo de testes (rascunho)</span>
              </label>
              <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '8px' }}>
                Os documentos são criados em rascunho/testes (não certificados, sem usar séries reais).
                Útil enquanto a conta Vendus não tem séries configuradas. Desligue para emitir faturas reais.
              </p>

              <div style={{ marginTop: '16px' }}>
                <Campo label="Domínio da conta Vendus">
                  <input
                    type="text"
                    value={cfg.vendus_dominio || ''}
                    onChange={e => set('vendus_dominio', e.target.value.trim())}
                    placeholder="ex.: andre-costa-2.vendus.pt"
                    style={{ ...inputStyle, width: '100%' }}
                  />
                </Campo>
                <p style={{ color: 'var(--cor-texto-suave)', fontSize: '12px', marginTop: '8px' }}>
                  O subdomínio da sua conta Vendus (visível no URL do painel). Usado para abrir cada
                  fatura diretamente no backoffice Vendus a partir da marcação. Só o domínio, sem
                  &quot;https://&quot; nem barras.
                </p>
              </div>
            </>
          )}
        </Secao>

        <Secao titulo="Configurações de envio de email">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <Campo label="Email de envio (From)">
              <input
                type="email"
                value={cfg.email_from || ''}
                onChange={e => set('email_from', e.target.value)}
                placeholder="noreply@seudominio.com"
                style={{ ...inputStyle, width: '100%' }}
              />
              <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginTop: '4px', display: 'block' }}>
                Endereço verificado no Resend. Os emails são enviados a partir deste endereço.
              </span>
            </Campo>
            <Campo label="Email de BCC (cópia oculta)">
              <input
                type="email"
                value={cfg.email_bcc || ''}
                onChange={e => set('email_bcc', e.target.value)}
                placeholder="arquivo@seudominio.com (opcional)"
                style={{ ...inputStyle, width: '100%' }}
              />
              <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginTop: '4px', display: 'block' }}>
                Se preenchido, todos os emails enviados terão uma cópia oculta para este endereço.
              </span>
            </Campo>
            <Campo label="Fuso horário">
              <select
                value={cfg.fuso_horario || 'Europe/Lisbon'}
                onChange={e => set('fuso_horario', e.target.value)}
                style={{ ...inputStyle, width: '100%' }}
              >
                <option value="Europe/Lisbon">Europe/Lisbon (Portugal Continental)</option>
                <option value="Atlantic/Azores">Atlantic/Azores (Açores)</option>
                <option value="Atlantic/Madeira">Atlantic/Madeira (Madeira)</option>
                <option value="Europe/London">Europe/London</option>
                <option value="Europe/Madrid">Europe/Madrid</option>
              </select>
              <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginTop: '4px', display: 'block' }}>
                Usado para calcular a hora de envio dos lembretes e aniversários.
              </span>
            </Campo>
          </div>
        </Secao>

        <Secao titulo="Email de confirmação — conteúdo">
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '18px' }}>
            <input
              type="checkbox"
              checked={cfg.email_confirmacao_ativo === 'true'}
              onChange={e => set('email_confirmacao_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Enviar email na confirmação da marcação</span>
          </label>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', opacity: cfg.email_confirmacao_ativo === 'true' ? 1 : 0.5 }}>
            <Campo label="Assunto">
              <AssuntoInput
                valor={cfg.email_assunto}
                onChange={v => set('email_assunto', v)}
                disabled={cfg.email_confirmacao_ativo !== 'true'}
                placeholder="Confirmação de Agendamento — {servico}"
                tags={['{servico}', '{profissional}', '{data}', '{hora}', '{nome}', '{nomeNegocio}']}
              />
            </Campo>
            <Campo label="Template HTML do email">
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '6px' }}>
                <button
                  type="button"
                  onClick={() => set('email_template_html', TEMPLATE_PADRAO)}
                  style={{ fontSize: '12px', padding: '3px 10px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo)', color: 'var(--cor-texto-suave)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}
                >
                  Repor template padrão
                </button>
              </div>
              <MensagemHtmlTextarea
                valor={cfg.email_template_html || ''}
                onChange={v => set('email_template_html', v)}
                nomeNegocio={cfg.nome_negocio}
                isTemplate={true}
                tags={['{nome}', '{nomeCompleto}', '{servico}', '{profissional}', '{data}', '{hora}', '{horaFim}', '{nomeNegocio}', '{morada}', '{telefone}', '{notas}', '{gcalUrl}']}
                placeholder={TEMPLATE_PADRAO}
              />
            </Campo>
          </div>

          <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid var(--cor-borda)' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '10px' }}>Enviar email de teste</p>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <input
                type="email"
                value={emailTeste}
                onChange={e => setEmailTeste(e.target.value)}
                placeholder="email@destino.com"
                style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
              />
              <button
                type="button"
                onClick={enviarTeste}
                disabled={enviandoTeste || !emailTeste}
                style={{ padding: '9px 20px', borderRadius: 'var(--raio)', border: 'none', background: 'var(--cor-principal)', color: '#fff', fontSize: '14px', cursor: enviandoTeste || !emailTeste ? 'not-allowed' : 'pointer', opacity: enviandoTeste || !emailTeste ? 0.6 : 1, fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}
              >
                {enviandoTeste ? 'A enviar…' : 'Enviar teste'}
              </button>
            </div>
          </div>
        </Secao>

        <Secao titulo="Email de lembrete">
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '14px' }}>
            <input
              type="checkbox"
              checked={cfg.email_lembrete_ativo === 'true'}
              onChange={e => set('email_lembrete_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Enviar email de lembrete antes da marcação</span>
          </label>
          {cfg.email_lembrete_ativo === 'true' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                <Campo label="Dias antes da marcação">
                  <input
                    type="number" min="1" max="30" step="1"
                    value={cfg.email_lembrete_dias_antes || '1'}
                    onChange={e => set('email_lembrete_dias_antes', e.target.value)}
                    style={{ ...inputStyle, width: '140px' }}
                  />
                </Campo>
                <Campo label="Hora de envio (hora de Lisboa)">
                  <input
                    type="number"
                    min="0"
                    max="23"
                    value={cfg.email_lembrete_hora || '18'}
                    onChange={e => set('email_lembrete_hora', e.target.value)}
                    style={{ ...inputStyle, width: '80px' }}
                    placeholder="18"
                  />
                  <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginTop: '4px' }}></span>
                </Campo>
              </div>
              <Campo label="Assunto">
                <AssuntoInput
                  valor={cfg.email_lembrete_assunto}
                  onChange={v => set('email_lembrete_assunto', v)}
                  placeholder="Lembrete da sua marcação — {servico}"
                  tags={['{servico}', '{profissional}', '{data}', '{hora}', '{nome}', '{nomeNegocio}']}
                />
              </Campo>
              <Campo label="Template HTML do email">
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '6px' }}>
                  <button
                    type="button"
                    onClick={() => set('email_lembrete_mensagem', TEMPLATE_LEMBRETE_PADRAO)}
                    style={{ fontSize: '12px', padding: '3px 10px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo)', color: 'var(--cor-texto-suave)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}
                  >
                    Repor template padrão
                  </button>
                </div>
                <MensagemHtmlTextarea
                  valor={cfg.email_lembrete_mensagem || ''}
                  onChange={v => set('email_lembrete_mensagem', v)}
                  nomeNegocio={cfg.nome_negocio}
                  isTemplate={true}
                  tags={['{nome}', '{nomeCompleto}', '{servico}', '{profissional}', '{data}', '{hora}', '{horaFim}', '{nomeNegocio}', '{morada}', '{telefone}', '{notas}']}
                  placeholder={TEMPLATE_LEMBRETE_PADRAO}
                />
              </Campo>
            </div>
          )}
          <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid var(--cor-borda)' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '10px' }}>Enviar email de teste</p>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <input
                type="email"
                value={emailTesteLembrete}
                onChange={e => setEmailTesteLembrete(e.target.value)}
                placeholder="email@destino.com"
                style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
              />
              <button
                type="button"
                onClick={enviarTesteLembrete}
                disabled={enviandoTesteLembrete || !emailTesteLembrete}
                style={{ padding: '9px 20px', borderRadius: 'var(--raio)', border: 'none', background: 'var(--cor-principal)', color: '#fff', fontSize: '14px', cursor: enviandoTesteLembrete || !emailTesteLembrete ? 'not-allowed' : 'pointer', opacity: enviandoTesteLembrete || !emailTesteLembrete ? 0.6 : 1, fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}
              >
                {enviandoTesteLembrete ? 'A enviar…' : 'Enviar teste'}
              </button>
            </div>
          </div>
        </Secao>

        <Secao titulo="Email de aniversário">
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '14px' }}>
            <input
              type="checkbox"
              checked={cfg.aniversario_email_ativo === 'true'}
              onChange={e => set('aniversario_email_ativo', e.target.checked ? 'true' : 'false')}
              style={{ width: '16px', height: '16px', accentColor: 'var(--cor-principal)' }}
            />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Enviar email de aniversário</span>
          </label>
          {cfg.aniversario_email_ativo === 'true' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <Campo label="Hora de envio (hora de Lisboa)">
                <input
                  type="number"
                  min="0"
                  max="23"
                  value={cfg.aniversario_email_hora || '9'}
                  onChange={e => set('aniversario_email_hora', e.target.value)}
                  style={{ ...inputStyle, width: '80px' }}
                  placeholder="9"
                />
                <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginTop: '4px' }}></span>
              </Campo>
              <Campo label="Assunto">
                <AssuntoInput
                  valor={cfg.aniversario_email_assunto}
                  onChange={v => set('aniversario_email_assunto', v)}
                  placeholder="Feliz aniversário, {nome}!"
                  tags={['{nome}', '{nomeNegocio}', '{idade}']}
                />
              </Campo>
              <Campo label="Template HTML do email">
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '6px' }}>
                  <button
                    type="button"
                    onClick={() => set('aniversario_email_mensagem', TEMPLATE_ANIVERSARIO_PADRAO)}
                    style={{ fontSize: '12px', padding: '3px 10px', borderRadius: 'var(--raio)', border: '1px solid var(--cor-borda)', background: 'var(--cor-fundo)', color: 'var(--cor-texto-suave)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}
                  >
                    Repor template padrão
                  </button>
                </div>
                <MensagemHtmlTextarea
                  valor={cfg.aniversario_email_mensagem || ''}
                  onChange={v => set('aniversario_email_mensagem', v)}
                  nomeNegocio={cfg.nome_negocio}
                  isTemplate={true}
                  tags={['{nome}', '{nomeNegocio}', '{idade}']}
                  placeholder={TEMPLATE_ANIVERSARIO_PADRAO}
                />
              </Campo>
            </div>
          )}
          <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid var(--cor-borda)' }}>
            <p style={{ fontSize: '13px', fontWeight: '500', marginBottom: '10px' }}>Enviar email de teste</p>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <input
                type="email"
                value={emailTesteAniversario}
                onChange={e => setEmailTesteAniversario(e.target.value)}
                placeholder="email@destino.com"
                style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
              />
              <button
                type="button"
                onClick={enviarTesteAniversario}
                disabled={enviandoTesteAniversario || !emailTesteAniversario}
                style={{ padding: '9px 20px', borderRadius: 'var(--raio)', border: 'none', background: 'var(--cor-principal)', color: '#fff', fontSize: '14px', cursor: enviandoTesteAniversario || !emailTesteAniversario ? 'not-allowed' : 'pointer', opacity: enviandoTesteAniversario || !emailTesteAniversario ? 0.6 : 1, fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}
              >
                {enviandoTesteAniversario ? 'A enviar…' : 'Enviar teste'}
              </button>
            </div>
          </div>
        </Secao>

        <button
          type="submit"
          className="btn-primario"
          disabled={guardando}
          style={{ opacity: guardando ? 0.6 : 1, width: '100%', padding: '14px' }}
        >
          {guardando ? 'A guardar…' : 'Guardar'}
        </button>
      </form>
    </div>
  )
}
